module.exports = __webpack_public_path__ + "img/check-big.df0ad6fa.svg";